<template>
  <div class="about-modular">
    <div class="media-banner">
      <div class="media-title EC5 center">媒体报道</div>
    </div>
    <div class="news-content w1200">
      <ul>
        <li
          v-for="item in 10"
          :key="`al_${item}`"
          :class="`news-item ${item > 6 && !isMore ? 'hide' : ''}`"
        >
          <div class="left newsinfo-img">
            <img
              :src="require('@/assets/images/about2.png')"
              alt=""
              class="news-img"
            />
          </div>
          <div class="right desc">
            <h2 class="news-title">
              <a href="/" target="_blank"
                >新华社：新教育风口初显，知链多向价值网打通教育全场景</a
              >
            </h2>
            <p class="news-short">
              <a href="/" target="_blank"> </a>
            </p>
            <p class="news-origin">
              <span>新华社</span>
              |
              <span>2019-6-20</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="more-btn center">
        <span v-if="isMore" class="MediumBtnType3" @click="showMore(false)"
          >收起报道</span
        >
        <span v-else class="MediumBtnType3" @click="showMore(true)"
          >查看更多</span
        >
      </div>
    </div>
    
  </div>
</template>

<script>
import Free from '@/components/Free';
export default {
  data() {
    return { isMore: false };
  },
  methods: {
    showMore(bool) {
      this.isMore = bool;
    }
  },
  components: {
    'v-free': Free
  }
};
</script>

<style lang="scss">
.about-modular {
  .media-banner {
    height: 360px;
    padding-top: 160px;
    background: url('~@/assets/images/about1.png') center no-repeat;
    background-size: cover;
  }
  .media-banner .media-title {
    margin-bottom: 0;
    font-size: 64px;
    font-weight: 600;
  }
  .newsinfo-img {
    margin-right: 25px;
  }
  .news-content {
    padding-top: 60px;
    padding-bottom: 90px;
  }
  .news-item {
    margin-bottom: 40px;
    height: 140px;
    position: relative;
    padding-left: 282px;
  }
  .news-img {
    width: 250px;
    height: 140px;
    position: absolute;
    left: 0;
    top: 0;
  }
  .news-title {
    font-size: 20px;
    height: 28px;
    line-height: 28px;
    margin-bottom: 10px;
  }
  .news-title a {
    color: #333;
  }
  .news-short {
    font-size: 16px;
    line-height: 26px;
    height: 80px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .news-short a {
    color: #888;
  }
  .news-origin {
    color: #666;
    line-height: 30px;
    font-size: 12px;
  }
  .news-origin a {
    color: #666;
  }
  .more-btn {
    margin: 70px auto 0;
  }
}
.app .about-modular {
  padding-top: 1.04rem;
  .media-banner {
    height: 2.4rem;
    padding: 0;
    color: #333;
    font-size: 0.4rem;
    background: url('~@/assets/images/join1_app.png') no-repeat;
    background-size: contain;

    .media-title {
      line-height: 2.4rem;
      color: #333;
      font-size: 0.4rem;
      font-weight: normal;
    }
  }
  .news-content {
    padding: 1.2rem 0.76rem;
    background: rgba(0, 0, 0, 0.05);
    .news-item {
      display: block;
      height: auto;
      margin-bottom: 1.2rem;
      padding: 0;
      .newsinfo-img {
        margin: 0 0 0.44rem;
        img {
          position: static;
          width: 100%;
          height: auto;
        }
      }
      .news-title {
        font-size: 0.36rem;
        line-height: 0.5rem;
        margin: 0 0 0.2rem;
        height: auto;
      }
      .news-short {
        height: auto;
        color: #888;
        line-height: 0.48rem;
        font-size: 0.28rem;
        margin-bottom: 0.32rem;
      }
      .news-origin {
        color: #666;
        line-height: 0.34rem;
        font-size: 0.24rem;
        text-align: left;
      }
    }
  }
  .more-btn {
    margin: 0.5rem auto;
    .MediumBtnType3 {
      width: 2.76rem;
      height: 0.8rem;
      border-radius: 0.08rem;
      line-height: 0.8rem;
      font-size: 0.32rem;
      padding: 0;
    }
  }
}
</style>
